import { ax } from '../utils/axios'
import { BASE_API_URL } from '../constants'

export const apiDRSGet = ({
  drsId,
  roleId,
}: {
  drsId: string,
  roleId: string,
}) => {
  // Strip any non-digit suffix accidentally pulled in from a URL hash fragment
  // (e.g. "148696#ShiftProfitability" -> "148696").
  const cleanDrsId = String(drsId).match(/^\d+/)?.[0] ?? drsId
  const options = {
    method: 'GET',
    url: `${BASE_API_URL}/drs/${cleanDrsId}/details`,
    params: {
      role: roleId,
    },
  }
  return ax(options)
}